<template>
  <div class="components-title">
    <div class="components-title-list">
      <i :class="['line', wordMode + '-line']"></i>
      <span v-for="item in titleList" :class="[wordMode + '-word']" :key="item">{{ item }}</span>
      <i :class="['line', wordMode + '-line']"></i>
    </div>
    <div
      v-if="EnglishTitle"
      :class="['components-title-english', 'components-title-english-' + wordMode ]"
    >{{ EnglishTitle }}</div>
  </div>
</template>

<script>
  export default {
    name: 'Title',
    props: {
      title: {
        type: String,
        required: true,
      },
      EnglishTitle: {
        type: String,
      },
      mode: {
        type: String,
        default: 'black',
      },
    },
    computed: {
      titleList() {
        return this.title.split('');
      },
      wordMode() {
        return this.mode === 'white' ? 'white' : 'black';
      },
    },
  };
</script>
<style lang="scss">
  .components-title {
    display: block;
    width: 100%;
    text-align: center;

    &-list {
      display: flex;
      align-items: center;
      justify-content: center;

      span {
        padding: 0 15px;
        font-size: 24px;
        font-weight: 500;
        letter-spacing: 2px;
        line-height: 28px;
      }

      .white-word {
        color: rgba(255, 255, 255, 1);
        border-left: 1px solid rgba(255, 255, 255, 1);

        &:nth-last-child(2) {
          border-right: 1px solid rgba(255, 255, 255, 1);
        }
      }

      .black-word {
        color: rgba(51, 51, 51, 1);
        border-left: 1px solid rgba(102, 102, 102, 1);

        &:nth-last-child(2) {
          border-right: 1px solid rgba(102, 102, 102, 1);
        }
      }

      .line {
        display: inline-block;
        width: 50px;
        height: 1px;
      }

      .white-line {
        background-color: rgba(255, 255, 255, 1);
      }

      .black-line {
        background-color: rgba(102, 102, 102, 1);
      }
    }

    &-english {
      padding-top: 20px;
      font-size: 12px;
      letter-spacing: 1px;
    }

    &-english-white {
      color: rgba(255, 255, 255, 1);
    }

    &-english-black {
      color: rgba(102, 102, 102, 1);
    }
  }
</style>
